import React, { useEffect, useState } from 'react';
import { AppBar, Tabs, Tab, Typography, Box, useTheme, Button, Drawer, IconButton, TextField, useMediaQuery, Grid, InputAdornment } from '@mui/material';
import { tokens } from "../../theme";
import CloseIcon from '@mui/icons-material/Close';
import { io } from 'socket.io-client';

const socket = io('https://ethioinstallglobaltrade.com', {
    path: '/socket.io', // Ensure this matches the backend
    // transports: ['websocket'], // Force WebSocket transport
    // transports: ['websocket', 'polling'],
    secure: true, // Required for HTTPS/WSS
});

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
};

const MapComponent = () => {
  const [value, setValue] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [start, setStart] = useState('');
  const [destination, setDestination] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    socket.on('connection', () => {
      console.log(`Connected to server: ${socket.id}`);
    });
    
    socket.on('connect_error', (error) => {
      console.error('Connection error:', error.message);
    });

    socket.on('orderCreated', (data) => {
      console.log('Order created event received:', data);
    });

    return () => {
      // Clean up on component unmount
      socket.off('orderCreated');
    };

    // Handle disconnection
    socket.on('disconnect', () => {
      console.log('Disconnected from server');
    });

    return () => {
        socket.disconnect(); // Cleanup on component unmount
    };
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNewOrder = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handlePlaceOrder = () => {
    alert(`Order placed from ${start} to ${destination}`);
    handleDrawerClose(); // Close drawer after placing the order
  };


  return (
    <Box style={{ padding: 20 }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{ backgroundColor: `${colors.primary[500]} !important`, }}
        >
          <Tab label="Live" />
          <Tab label="Waiting" />
          <Tab label="Active" />
          <Tab label="Free" />
          <Tab label="Completed" />
          <Tab label="Cancelled" />
          <Tab label="Rejected" />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Grid container> {/*spacing={2} */}
          <Grid item xs={12} md={8}>
            {/* Google Map Embed */}
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345091856!2d144.95373631531668!3d-37.81627997975154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11c6f7%3A0x5045675218cd0f0!2sFederation%20Square!5e0!3m2!1sen!2sau!4v1615687479208!5m2!1sen!2sau"
              width="100%"
              height="455"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
            {/* New Order Button (visible only on small screens) */}
            {isSmallScreen && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleNewOrder}
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  right: 16,
                  zIndex: 1,
                }}
              >
                New Order
              </Button>
            )}
          </Grid>
          {!isSmallScreen && (
          <Grid item xs={12} md={4}>
            <Box sx={{ padding: 2, height: '99%', backgroundColor: colors.primary[400] }}>
              <Typography variant="h6">Manual Order</Typography>
              <TextField
                label="Start Location"
                variant="outlined"
                fullWidth
                margin="normal"
                value={start}
                onChange={(e) => setStart(e.target.value)}
              />
              <TextField
                label="Destination"
                variant="outlined"
                fullWidth
                margin="normal"
                value={destination}
                onChange={(e) => setDestination(e.target.value)}
              />
              <TextField
                label="Customer Phone"
                variant="outlined"
                fullWidth
                margin="normal"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="9XX XXX XXX"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+251</InputAdornment>
                  ),
                }}    
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handlePlaceOrder}
                sx={{ marginTop: 2 }}
              >
                Place Order
              </Button>
            </Box>
          </Grid>
          )}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Typography variant="h6">Waiting page</Typography>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Typography variant="h6">Active page</Typography>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Typography variant="h6">Free page</Typography>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Typography variant="h6">Completed page</Typography>
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Typography variant="h6">Cancelled page</Typography>
      </TabPanel>
      <TabPanel value={value} index={6}>
        <Typography variant="h6">Rejected page</Typography>
      </TabPanel>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => {}} // Prevent closing on backdrop click
      >
        <Box sx={{ width: 300, height: '100%', padding: 2, backgroundColor: `${colors.primary[400]}` }}>
          <IconButton onClick={handleDrawerClose} sx={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6">Manual Order</Typography>
          <TextField
            label="Start Location"
            variant="outlined"
            fullWidth
            margin="normal"
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
          <TextField
            label="Destination"
            variant="outlined"
            fullWidth
            margin="normal"
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
          />
          <TextField
            label="Customer Phone"
            variant="outlined"
            fullWidth
            margin="normal"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="9XX XXX XXX" // Example format without country code
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">+251</InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handlePlaceOrder}
            sx={{ marginTop: 2 }}
          >
            Place Order
          </Button>
        </Box>
      </Drawer>
    </Box>
  );
};

export default MapComponent;